import * as THREE from 'three';
import {GlobalManager} from '@/core/GlobalManager.js';

/**
 * 创建一个透视相机 (PerspectiveCamera)
 * @param {number} width - 渲染画布的宽度
 * @param {number} height - 渲染画布的高度
 * @returns {THREE.PerspectiveCamera}
 */
export function genPerspectiveCamera(){
    var window = GlobalManager.get("window");
    let camera = new THREE.PerspectiveCamera(70, window.innerWidth / window.innerHeight, 0.1, 1000);
    camera.position.x = 0;
    camera.position.y = 2;
    camera.position.z = 5;
    camera.lookAt(0,0,0);
    return camera;
}


/**
 * 创建一个正交相机 (OrthographicCamera)
 * @param {number} width - 渲染画布的宽度
 * @param {number} height - 渲染画布的高度
 * @returns {THREE.OrthographicCamera}
 */
export function genOrthographicCamera() {
    var window = GlobalManager.get("window");
    // 1. 定义相机视锥体的垂直大小 (这可以类比于透视相机的FOV，但单位是世界单位)
    // 值越小，物体看起来越大；值越大，能看到的范围越广。
    const viewSize = 7; 

    // 2. 根据画布宽高比计算水平大小
    const aspectRatio = window.innerWidth / window.innerHeight;
    const halfHeight = viewSize / 2;
    const halfWidth = halfHeight * aspectRatio;
    

    // 3. 创建正交相机
    // 参数: left, right, top, bottom, near, far
    let camera = new THREE.OrthographicCamera(
        -halfWidth,   // left
         halfWidth,   // right
         halfHeight,  // top
        -halfHeight,  // bottom
        0.1,          // near (近裁剪面)
        1000          // far (远裁剪面)
    );

    // 4. 设置相机位置和朝向 (与你的透视相机完全相同)
    camera.position.x = 0;
    camera.position.y = 0;
    camera.position.z = 5;
    camera.lookAt(0, 0, 0);

    return camera;
}